import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const CampaignGroup = styled.div`
  width: 100%;

  .pj-ui-panel--grid {
    margin: 1.5rem 0;
    list-style: none;
    flex-wrap: nowrap;

    ${media.smallOnly`
      flex-wrap: wrap;
      align-items: center;
      flex-direction: column;
    `}
  }
`;

export const CampaignListItem = styled.li`
  padding: 20px;
  border-right: 1px solid ${p => p.theme.lines.secondary};
  flex: 1;
  text-align: center;

  &:last-child {
    border: none;
  }

  ${media.smallOnly`
    width: 100%;
    max-width: 100%;
    border: none;
    border-bottom: 1px solid ${p => p.theme.lines.secondary};
  `}
`;
